import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import PlayersTable from "../../components/PlayersTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getPlayersDetails, savePlayers } from "../../api/dataCapture";
import { resetSelectedPlayer, setIsUpdatedPlayer, setPlayerDetails } from "../../redux/reducers/dataCaptures";
import PlayerDetailPage from "../PlayerDetailPage";
import AddPlayerForm from "../AddPlayerForm";

const PlayersDetails = () => {
    const [addPlayer, setAddPlayer] = React.useState(false);
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const playerDetails = useSelector((state:any) => state.dataCaptures.playerDetails);
    const selectedPlayer = useSelector((state:any) => state.dataCaptures.selectedPlayer);
    const isUpdatedPlayer = useSelector((state:any) => state.dataCaptures.isUpdatedPlayer);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    useEffect(() => {
        const fetchPlayersDetails = async () => {
            const response = await getPlayersDetails({clubId: clubDetails.id, isPast: false});
            dispatch(setPlayerDetails(response));
        }
        fetchPlayersDetails();
    }, []);
    
    const handlePlayerDetailsClose = async () => {
        if (isUpdatedPlayer) {
            const updatedList = playerDetails?.map((item:any) => item?.id == selectedPlayer?.id ? selectedPlayer : item);
            const response = await savePlayers({clubId: clubDetails?.id, data: updatedList});
            dispatch(setPlayerDetails(response));
            const boolean:any = false;
            dispatch(setIsUpdatedPlayer(boolean));
        } dispatch(resetSelectedPlayer());
    }
    
    const createNewPlayer = (newPlayer:any) => {
        const updatedData = [...playerDetails, newPlayer];
        savePlayers({clubId: clubDetails?.id, data: updatedData})
        .then((res:any) => {
        dispatch(setPlayerDetails(res));
        });
        setAddPlayer(false);
    }

    return (
        <Box>
            {!isAdmin && addPlayer && <AddPlayerForm onCancelClick={() => {setAddPlayer(false)}} onAddClick={createNewPlayer} />}
            <PlayerDetailPage isOpen={selectedPlayer && Object.keys(selectedPlayer)?.length > 0} handleClose={handlePlayerDetailsClose} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography className='standardsHeading uppercase'>Players table</Typography>
                {
                    !isAdmin &&
                    <Button className='smallButton' 
                    sx={{ float: 'right' }} disableElevation 
                    disabled={addPlayer} 
                    variant='contained' 
                    size='small' 
                    onClick={() => {setAddPlayer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                        {'Add new player'}
                    </Button>
                }
            </Box>
            <PlayersTable addData={addPlayer} handleClick={() => setAddPlayer(false)}/>
        </Box>
    )
}

export default PlayersDetails;